import * as React from 'react';

import Checkout from 'src/components/Checkout';

import './CheckoutView.scss';
import i18n from 'src/translation/i18n';

class CheckoutView extends React.Component {
  public render() {
    return (
      <div className="rp-checkout-view">
        <div className="rp-checkout-view--breadcrumbs">
          <span>
            {i18n.t('common.home')} / {i18n.t('common.checkout')}{' '}
          </span>
        </div>
        <Checkout />
      </div>
    );
  }
}

export default CheckoutView;
